export default __webpack_public_path__ + "static/media/sib.df2b52ec.png";